export * from "./LegalScreen";
export * from "./CookiesScreen";
export * from "./PrivacyScreen";
export * from "./ManagementPolicy";
export * from "./SecurityPolicy";
